import { render, staticRenderFns } from "./OverviewPart.vue?vue&type=template&id=580e6048"
import script from "./OverviewPart.vue?vue&type=script&lang=js"
export * from "./OverviewPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('580e6048')) {
      api.createRecord('580e6048', component.options)
    } else {
      api.reload('580e6048', component.options)
    }
    module.hot.accept("./OverviewPart.vue?vue&type=template&id=580e6048", function () {
      api.rerender('580e6048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/OverviewPart.vue"
export default component.exports